import { VTextField } from 'vuetify/lib/components/VTextField';

var render = function render(){var _vm=this,_c=_vm._self._c;return _c(VTextField,{class:_vm.searchClass,attrs:{"flat":"","dense":"","clearable":"","prepend-icon":"mdi-magnify","placeholder":"Type to search . . ."},model:{value:(_vm.keyword),callback:function ($$v) {_vm.keyword=$$v},expression:"keyword"}})
}
var staticRenderFns = []

export { render, staticRenderFns }